// extracted by mini-css-extract-plugin
module.exports = {"button-p":"SignQuoteTab_button-p__1e4K3","button":"SignQuoteTab_button__11-vC"};